import styled from 'styled-components';

export const ErrorPaymentModalWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -16px;

  & .error-icon {
    margin-bottom: 25px;
  }

  & .error-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #1d201f;
    margin-bottom: 10px;
  }

  & .error-message {
    width: fit-content;
    background: #f2f4f7;
    border: 1px solid #c1c1c1;
    border-radius: 5px;
    padding: 5px 10px;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #f24e1e;
    margin-bottom: 10px;
  }

  & .error-repeat {
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #1d201f;
    margin-bottom: 30px;
  }
`;
